<template>
  <header class="sales-history__header">
    <div class="sales-history__heading">
      <span class="sales-history__icon">
        <Receipt :size="22" />
      </span>

      <div>
        <h2>Продажи за смену</h2>
        <p>Все покупки и их состав в одном месте</p>
      </div>
    </div>

    <button
      class="sales-history__refresh"
      :disabled="isDisabled"
      @click="$emit('refresh')"
    >
      <RefreshCw :size="16" />
      Обновить
    </button>
  </header>
</template>

<script>
import { Receipt, RefreshCw } from 'lucide-vue'

export default {
  name: 'HistoryHeader',
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    isOpenedWorkingShift: {
      type: Boolean,
      default: false
    }
  },
  components: { Receipt, RefreshCw },
  computed: {
    isDisabled () {
      return this.isLoading || !this.isOpenedWorkingShift
    }
  }
}
</script>

<style scoped lang="scss" src="./style.scss" />
